module.exports = __webpack_public_path__ + "media/images/pages/solutions/automation/dashboard-830b930d3aa658af2296c598dcb8ff36.png";